const RangeEveryday = [
    {
        image: "https://m.media-amazon.com/images/I/81ud9DR6h2L._AC_SX679_.jpg",
        imageover: "https://m.media-amazon.com/images/I/81wBzJVjRNL._AC_SX679_.jpg",
        href: "https://www.amazon.co.uk/dp/B0CTCV4J83",
        title: "It's A Girl Cookie Stamp Embosser",
        subtitle: "£3.99",
        featured: true,
    },
    {
        image: "https://m.media-amazon.com/images/I/816x55Kf8fL._AC_SX679_.jpg",
        imageover: "https://m.media-amazon.com/images/I/81QJoobdkdL._AC_SX679_.jpg",
        href: "https://www.amazon.co.uk/dp/B0CTCQ3GGQ",
        title: "It's A Boy Cookie Stamp Embosser",
        subtitle: "£3.99",
        featured: true,
    },
    {
        image: "https://m.media-amazon.com/images/I/71ex00zgXSL._AC_SX679_.jpg",
        imageover: "https://m.media-amazon.com/images/I/81sKIBoRr9L._AC_SX679_.jpg",
        href: "https://www.amazon.co.uk/dp/B0D783W5V4",
        title: "Girl Or Boy Cookie Stamp Embosser",
        subtitle: "£3.99",
        featured: false,
    },
    {
        image: "https://m.media-amazon.com/images/I/71gqKaxjO6L._AC_SX679_.jpg",
        imageover: "https://m.media-amazon.com/images/I/71MU1beDy-L._AC_SX679_.jpg",
        href: "https://www.amazon.co.uk/dp/B0F8LP419K",
        title: "Boy Or Girl Cookie Stamp Embosser",
        subtitle: "£3.99",
        featured: false,
    },
    {
        image: "https://m.media-amazon.com/images/I/71ATDM0fDZL._AC_SX679_.jpg",
        imageover: "https://m.media-amazon.com/images/I/71OkF8rl0oL._AC_SX679_.jpg",
        href: "https://www.amazon.co.uk/dp/B0F8LR2V7T",
        title: "He Or She Cookie Stamp Embosser",
        subtitle: "£3.99",
        featured: false,
    },
    {
        image: "https://m.media-amazon.com/images/I/81J2Te3O3tL._AC_SX679_.jpg",
        imageover: "https://m.media-amazon.com/images/I/81SKEINfoZL._AC_SX679_.jpg",
        href: "https://www.amazon.co.uk/dp/B0CTCTB6Y9",
        title: "Happy Anniversary Cookie Stamp Embosser",
        subtitle: "£3.99",
        featured: false,
    },
    {
        image: "https://m.media-amazon.com/images/I/81iDZf3I-TL._AC_SX679_.jpg",
        imageover: "https://m.media-amazon.com/images/I/81DI+HogmnL._AC_SX679_.jpg",
        href: "https://www.amazon.co.uk/dp/B0CTCRVYW6",
        title: "Well Done Cookie Stamp Embosser",
        subtitle: "£3.99",
        featured: false,
    },
    {
        image: "https://m.media-amazon.com/images/I/81YWYMP6YJL._AC_SX679_.jpg",
        imageover: "https://m.media-amazon.com/images/I/81q1qXacqhL._AC_SX679_.jpg",
        href: "https://www.amazon.co.uk/dp/B0CQMS2HXF",
        title: "Good Luck Cookie Stamp Embosser",
        subtitle: "£3.99",
        featured: false,
    },
    {
        image: "https://m.media-amazon.com/images/I/71zioX6r1kL._AC_SL1297_.jpg",
        imageover: "https://m.media-amazon.com/images/I/719lFt03EkL._AC_SX679_.jpg",
        href: "https://www.amazon.co.uk/dp/B0F8LLG2NL",
        title: "Congrats Cookie Stamp Embosser",
        subtitle: "£3.99",
        featured: false,
    },
    {
        image: "https://m.media-amazon.com/images/I/819ZqrCVH6L._AC_SX679_.jpg",
        imageover: "https://m.media-amazon.com/images/I/81tXppY0SeL._AC_SX679_.jpg",
        href: "https://www.amazon.co.uk/dp/B0CQMKFL6S",
        title: "Thank You Cookie Stamp Embosser",
        subtitle: "£3.99",
        featured: false,
    },
    {
        image: "https://m.media-amazon.com/images/I/71n0gskIx0L._AC_SX679_.jpg",
        imageover: "https://m.media-amazon.com/images/I/81AFBrlp+GL._AC_SX679_.jpg",
        href: "https://www.amazon.co.uk/dp/B0D6LN8N4H",
        title: "You Are Awesome Cookie Stamp Embosser",
        subtitle: "£3.99",
        featured: false,
    },
    {
        image: "https://m.media-amazon.com/images/I/816rJurOs-L._AC_SX679_.jpg",
        imageover: "https://m.media-amazon.com/images/I/81zQX25EPvL._AC_SX679_.jpg",
        href: "https://www.amazon.co.uk/dp/B0CQMTVD58",
        title: "Happy Birthday Cookie Stamp Embosser",
        subtitle: "£3.99",
        featured: false,
    },
    {
        image: "https://m.media-amazon.com/images/I/71I7bJrXokL._AC_SX679_.jpg",
        imageover: "https://m.media-amazon.com/images/I/81o1ml5BrkL._AC_SX679_.jpg",
        href: "https://www.amazon.co.uk/dp/B0D6LLCYQL",
        title: "Happy Birthday Cake Cookie Stamp Embosser",
        subtitle: "£3.99",
        featured: false,
    },
    {
        image: "https://m.media-amazon.com/images/I/71WmDg+5cqL._AC_SX679_.jpg",
        imageover: "https://m.media-amazon.com/images/I/71GNjrSW0EL._AC_SX679_.jpg",
        href: "https://www.amazon.co.uk/dp/B0F8LY1RC9",
        title: "Home Sweet Home Cookie Stamp Embosser",
        subtitle: "£3.99",
        featured: false,
    },
    {
        image: "https://m.media-amazon.com/images/I/71pXZNZ+zpL._AC_SX679_.jpg",
        imageover: "https://m.media-amazon.com/images/I/71DqA1mNW5L._AC_SX679_.jpg",
        href: "https://www.amazon.co.uk/dp/B0F8LCWWBS",
        title: "Mr & Mrs Cookie Stamp Embosser",
        subtitle: "£3.99",
        featured: false,
    },
    {
        image: "https://m.media-amazon.com/images/I/71Y4lwXkydL._AC_SX679_.jpg",
        imageover: "https://m.media-amazon.com/images/I/71xq6Xi51IL._AC_SX679_.jpg",
        href: "https://www.amazon.co.uk/dp/B0F8LR9PRX",
        title: "Oh Baby Cookie Stamp Embosser",
        subtitle: "£3.99",
        featured: false,
    },
    {
        image: "https://m.media-amazon.com/images/I/71uAw2PjhUL._AC_SX679_.jpg",
        imageover: "https://m.media-amazon.com/images/I/81htJMXnwTL._AC_SX679_.jpg",
        href: "https://www.amazon.co.uk/dp/B0D6LLGMN5",
        title: "Best Teacher Ever Cookie Stamp Embosser",
        subtitle: "£3.99",
        featured: false,
    },
];

RangeEveryday.forEach((item, i, self) => self[i].collection = "everyday")

export default RangeEveryday;
